import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore,applyMiddleware} from 'redux';
import reducer from './reducers/index';
import {Map as map} from 'immutable';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
//import logger from 'redux-logger';
import thunk from 'redux-thunk';

//styles
import 'bootstrap/dist/css/bootstrap.css';
import "./resources/styles/dashboardStyle.css";
import "./resources/styles/dashboardCustomStyle.css";
import "./resources/styles/publicStyles.css";
import App from './routes/App';

//create store of app
const store = createStore(
  reducer,
  map(),
  composeWithDevTools(
    applyMiddleware(
      /*logger,*/thunk
    ),
  ));

ReactDOM.render(
  //define provider
  <Provider store={store}>
    <App />
  </Provider>
  ,document.getElementById('app'),
);
